import {createReducer, on} from '@ngrx/store';
import {IPageNotFoundState} from '../models/page-not-found-state.model';
import {resetPageNotFound, setPageNotFound, setRedirectUrl} from './page-not-found.actions';

const initialState: IPageNotFoundState = {
  isPageNotFound: false,
  redirectUrl: '',
};

export const pageNotFoundReducer = createReducer(
  initialState,
  on(setPageNotFound, state => ({
    ...state,
    isPageNotFound: true,
  })),
  on(resetPageNotFound, state => ({
    ...state,
    ...initialState,
  })),
  on(setRedirectUrl, (state, redirectState) => ({
    ...state,
    redirectUrl: redirectState.redirectUrl,
  }))
);
